import { useEffect } from 'react';

const useKeyPress = (key, action) => {
  useEffect(() => {
    const onKeyup = event => {
      if (event.key === key) action();
    };
    window.addEventListener('keyup', onKeyup);
    return () => window.removeEventListener('keyup', onKeyup);
  }, [key, action]);
};

export { useKeyPress };
